import React from "react";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { styled, createTheme } from "@mui/material/styles";
const defaultTheme = createTheme();

export const CopyrightStyle = styled("div")(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  width: "100%",
  padding: 5,
  textAlign: "right",
  [defaultTheme.breakpoints.down("md")]: { display: "none" },
}));
function RootCopyRight() {
  return (
    <>
      <CopyrightStyle>
        <Typography variant="body2" color="text.secondary">
          <Link
            style={{ textDecoration: "none", color: "inherit" }}
            to="https://youngsoft.in/"
          >
            {"© "} {new Date().getFullYear()} Youngsoft Inc.,
          </Link>
        </Typography>
      </CopyrightStyle>
    </>
  );
}

export default React.memo(RootCopyRight);
